import BaseComponent from 'source/lib/base_component';

let globalDisabled;

const BaseButton = BaseComponent.extend({
    name: 'base-button',
    initialize(options = {}) {
        this.enable();
        BaseComponent.prototype.initialize.call(this, options);
    },
    template(data) {
        return `<input type="${data.submit ? 'submit' : 'button'}">`;
    },
    events: {
        click: 'click'
    },
    disable() {
        globalDisabled = true;
    },
    enable() {
        globalDisabled = false;
    },
    globalSubmitDisabled() {
        return globalDisabled;
    }
});

export default BaseButton;



// WEBPACK FOOTER //
// ./static-source/js/lib/component/button/base.js